import { keyframes } from '@emotion/react'
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt'
import { Box } from '@mui/material'
import { GAME } from '@/components/game/gamey.js'
import JoulelingoCharacter from '@/components/game/JoulelingoCharacter.jsx'
import { useBranding } from '@/contexts/BrandingContext'
import useGamey from '@/hooks/useGamey'

const surge = keyframes`
  0% {
    opacity: 0.7;
    transform: scale(0.88) translateY(6px);
  }
  50% {
    opacity: 1;
    transform: scale(1.06) translateY(0);
  }
  100% {
    opacity: 0.7;
    transform: scale(0.88) translateY(6px);
  }
`

const SplashScreenPower = () => {
    const { isLoading } = useBranding()
    const gamey = useGamey()
    // The character only once the host's brand is known: while branding is still loading the
    // brand is the platform default, and a partner host must never see it flash up.
    const character = gamey && !isLoading

    return (
        <Box
            data-splash-character={character ? true : undefined}
            sx={{
                alignItems: 'center',
                backgroundColor: character ? GAME.mint : 'neutral.900',
                display: 'flex',
                height: '100vh',
                justifyContent: 'center',
                left: 0,
                p: 3,
                position: 'fixed',
                top: 0,
                width: '100vw',
                zIndex: 2000
            }}
        >
            {character ? (
                <JoulelingoCharacter label="Loading" mood="happy" size={120} />
            ) : (
                <ElectricBoltIcon
                    sx={{
                        animation: `${surge} 1s ease-in-out infinite`,
                        color: 'primary.main',
                        filter: (theme) =>
                            `drop-shadow(0 0 10px ${theme.palette.primary.main})`,
                        fontSize: 110
                    }}
                />
            )}
        </Box>
    )
}

export default SplashScreenPower
